import React, {useEffect, useRef, useState } from "react";
import "../../../../style/css/otpVerification.css";
import { createPortal } from "react-dom";

const OtpVerification = ({ show, onClose, onVerify }) => {
    const [otp, setOtp] = useState(["", "", "", ""]);
    const inputs = useRef([]);

    useEffect(() => {
        if (show) {
            inputs.current[0]?.focus();
        }
    }, [show]);

    const handleChange = (value, index) => {
        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < 3) {
            inputs.current[index + 1].focus();
        }
    };

    const handleKeyDown = (e, index) => {
        if (e.key === "Backspace" && !otp[index] && index > 0) {
            inputs.current[index - 1].focus();
        }
    };

    const handleVerify = () => {
        const otpValue = otp.join("");
        onVerify(otpValue);
    };

    if (!show) return null;

    return createPortal(
        <div className="otp-overlay">
            <div className="otp-modal">

                <h4 className="text-center mb-3">OTP Verification</h4>
                <p className="text-center mb-4">Enter the 4-digit OTP</p>

                <div className="otp-input-container">
                    {otp.map((digit, index) => (
                        <input
                            key={index}
                            ref={(el) => (inputs.current[index] = el)}
                            type="text"
                            maxLength="1"
                            value={digit}
                            onChange={(e) => handleChange(e.target.value, index)}
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            className="otp-input"
                        />
                    ))}
                </div>

                <button className="verify-btn mt-4" onClick={handleVerify}>
                    Verify OTP
                </button>

                <button className="close-btn mt-2" onClick={onClose}>
                    Cancel
                </button>

            </div>
        </div>,
        document.body
    );
};

export default OtpVerification;